import React from 'react';
import { Image, View, StyleSheet } from 'react-native';
import { Color, FontSize, CommonStyles as CS } from '../../styles';
import Images from '../../constants/Images';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { XSmallText, cardStyle } from './card.utils';
import RowView from '../RowView';
const HotelDetailHeaderPriceSection = ({ price, label }) => {
  return (
    <View style={styles.leftAlign}>
      <XSmallText style={styles.upperText}>{label}</XSmallText>
      <BaseText style={cardStyle.large}>{price}</BaseText>
    </View>
  );
};

const HotelDetailHeader = ({ item, roomTypeLabel, price }) => {
  return (
    <>
      <View style={CS.flex1}>
        <RowView style={CS.flex1}>
          <BaseText ellipsizeMode="tail" numberOfLines={1} style={cardStyle.medium}>
            {item.HotelName}
          </BaseText>
          {item.IsCorporateRate && <Icon style={styles.corporate} name="copyright" />}
        </RowView>
        <RowView style={CS.py2}>
          <Image style={[cardStyle.rating, CS.mr2]} source={Images.rating[item.RealRating]} />
          <Image
            style={cardStyle.rating}
            source={Images.tripadvisor[item.ReviewRating ? item.ReviewRating : 0]}
          />
        </RowView>
        <XSmallText style={cardStyle.grayColor}>{item.Address1}</XSmallText>
      </View>
      <HotelDetailHeaderPriceSection price={price + 'p/n'} label={roomTypeLabel} />
    </>
  );
};

const styles = StyleSheet.create({
  upperText: {
    color: Color.primary,
  },
  leftAlign: {
    alignItems: 'flex-end',
  },
  corporate: {
    fontSize: FontSize.small,
    color: Color.corporate,
  },
});

export default HotelDetailHeader;
